import React, { Component } from 'react';
import './DesignDescription.scss';
import { Button } from 'reactstrap';
import { Icons } from '../../../utilities';
import * as Constants from '../../../utilities/constants/Constants';
import { string } from '../../../localization';

class DesignDescription extends Component {
  state = {
    viewPriceIsVisible: false
  };

  viewPriceVisiblityHandler = () => {
    this.setState(prevState => ({
      ...prevState,
      viewPriceIsVisible: !prevState.viewPriceIsVisible
    }));
  };

  getAuthorCompoent = () => {
    const { data } = this.props;
    const type = data.imageSource;
    const userType = data.type;

    let authorComponent = null;
    if (type === Constants.UNSPLASH_IMAGE_SOURCE) {
      authorComponent = (
        <div>
          Photo {string.RIGHT_LOGO_TEXT_KEY}{' '}
          <a
            href={data.user.profileLink}
            target='_blank'
            rel='noopener noreferrer'
          >
            {data.name}
          </a>{' '}
          {type === Constants.UNSPLASH_IMAGE_SOURCE ? (
            <span>
              on{' '}
              <a
                href='https://unsplash.com/?utm_source=your_app_name&utm_medium=referral'
                target='_blank'
                rel='noopener noreferrer'
              >
                {type}
              </a>
            </span>
          ) : null}
        </div>
      );
    } else if (type === Constants.HP_MOSAIC_IMAGE_SOURCE) {
      authorComponent = (
        <div>
          {string.RIGHT_LOGO_TEXT_KEY} <span>{data.profileLink} </span>
          {data.name}
        </div>
      );
    } else if (
      type === Constants.DREAMSTIME_IMAGE_SOURCE ||
      type === Constants.ADOBE_STOCK_IMAGE_SOURCE
    ) {
      authorComponent = (
        <div className='designer-intro'>
          <span>{string.DESIGN_KEY}</span>
          <br />
          <span>
            {string.RIGHT_LOGO_TEXT_KEY} {data.author}
          </span>
          <br />
          <span>
            {data.views
              ? string.formatString(string.VIEWS_KEY, data.views)
              : null}
            {/* {data.views} {string.VIEWS_KEY} */}
          </span>
          <br />
          <span>
            {data.downloads
              ? string.formatString(string.DOWNLOADS_KEY, data.downloads)
              : null}
            {/*  {data.downloads} {string.DOWNLOADS_KEY} */}
          </span>
        </div>
      );
    } else if (
      type === Constants.GETTY_IMAGE_SOURCE ||
      type === Constants.I_STOCK_IMAGE_SOURCE
    ) {
      authorComponent = (
        <div className='designer-intro'>
          <span>{string.RIGHT_LOGO_TEXT_KEY}</span> <span> {data.artist}</span>
        </div>
      );
    } else {
      authorComponent = (
        <div className='designer-intro'>
          <span>{string.DESIGN_KEY}</span>
          <br />
          <span>
            {string.RIGHT_LOGO_TEXT_KEY}{' '}
            {userType === Constants.SCENE_KEY
              ? data.author
              : data.patternDesigner.display}
          </span>
          <br />
          <span>
            {userType === Constants.SCENE_KEY
              ? data.country
              : data.patternDesigner.country}
          </span>
        </div>
      );
    }
    return authorComponent;
  };

  getDescriptionComponent = () => {
    const { data } = this.props;
    const type = data.imageSource;
    const userType = data.type;
    let desciptionComponent = null;
    if (type === Constants.DREAMSTIME_IMAGE_SOURCE) {
      desciptionComponent = <p>{data.description}</p>;
    }
    if (
      type !== Constants.UNSPLASH_IMAGE_SOURCE ||
      type !== Constants.HP_MOSAIC_IMAGE_SOURCE ||
      userType == Constants.SCENE_KEY
    ) {
      desciptionComponent = (
        <p className='keywords-container'>{data.keywords}</p>
      );
    }
    return desciptionComponent;
  };

  getStyleComponent = () => {
    const { data } = this.props;
    const type = data.imageSource;
    let styleName = 'd-flex profile ';
    if (
      type === Constants.UNSPLASH_IMAGE_SOURCE ||
      type === Constants.HP_MOSAIC_IMAGE_SOURCE
    ) {
      styleName += 'profile-unsplash';
    }
    return styleName;
  };

  getViewButtonComponent = () => {
    const { data, onClose } = this.props;
    const type = data.imageSource;
    const userType = data.type;

    let buttonComponent = null;
    if (
      type === Constants.PATTERN_DESIGN_IMAGE_SOURCE ||
      type === Constants.DREAMSTIME_IMAGE_SOURCE ||
      userType === Constants.SCENE_KEY
    ) {
      buttonComponent = (
        <Button
          className='button gb-primary mt-2'
          color='secondary'
          onClick={() => {
            window.open(data.detailsUrl, '_blank');
            onClose();
          }}
        >
          {string.VIEW_DESIGN_DETAILS_KEY}
        </Button>
      );
    }
    return buttonComponent;
  };

  render() {
    const { data, onClose } = this.props;
    const type = data.imageSource;
    const userType = data.type;

    let profileURL = null;
    let imagePath = null;
    let viewText = string.VIEW_DESIGNER_PROFILE_KEY;

    if (type === Constants.PATTERN_DESIGN_IMAGE_SOURCE) {
      profileURL = data.patternDesigner.profileUrl;
      imagePath = data.patternDesigner.profileImageURL;
    } else if (
      type === Constants.GETTY_IMAGE_SOURCE ||
      type === Constants.I_STOCK_IMAGE_SOURCE
    ) {
      profileURL = data.viewUrl;
      imagePath = data.thumbnailPath;
      if (type == Constants.GETTY_IMAGE_SOURCE) {
        viewText = string.VIEW_GETTY_IMAGE_KEY;
      } else {
        viewText = string.VIEW_I_STOCK_KEY;
      }
    } else if (type === Constants.ADOBE_STOCK_IMAGE_SOURCE) {
      profileURL = data.detailsUrl;
      imagePath = data.thumbnailPath;
      viewText = string.VIEW_IN_ADOBE_STOCK_KEY;
    } else if (type === Constants.DREAMSTIME_IMAGE_SOURCE) {
      profileURL = data.profileURL;
      imagePath = data.profileImageURL;
    } else if (type === Constants.UNSPLASH_IMAGE_SOURCE) {
      imagePath = data.user.profileImage;
    } else if (type === Constants.HP_MOSAIC_IMAGE_SOURCE) {
      imagePath = data.imagePath;
    } else if (userType === Constants.SCENE_KEY) {
      profileURL = data.profileURL;
      imagePath = Icons.martina;
    }

    const styleComponent = this.getStyleComponent();
    const authorComponent = this.getAuthorCompoent();
    const descriptionComponent = this.getDescriptionComponent();
    const viewButtonComponent = this.getViewButtonComponent();

    return (
      <div id='design-description'>
        <div className='header d-flex'>
          <p>
            {type === Constants.UNSPLASH_IMAGE_SOURCE ||
            type === Constants.HP_MOSAIC_IMAGE_SOURCE ||
            userType === Constants.SCENE_KEY
              ? data.user.name
              : data.title}
          </p>

          <button
            type='button'
            onClick={onClose}
            style={{
              width: '20px',
              height: '20px',
              border: 'none',
              background: 'none',
              outline: 'none'
            }}
            alt='close'
          >
            <img
              src={Icons.closeHover}
              alt='close'
              style={{ marginLeft: '0px' }}
            />
          </button>
        </div>
        <div className={styleComponent}>
          <img src={imagePath} alt='profile' />

          {authorComponent}
        </div>
        {type === Constants.UNSPLASH_IMAGE_SOURCE ||
        type === Constants.HP_MOSAIC_IMAGE_SOURCE ? null : (
          <p>{string.FOTOLIA_KEYWORDS_KEY}</p>
        )}
        {descriptionComponent}

        {type === Constants.UNSPLASH_IMAGE_SOURCE ||
        type === Constants.HP_MOSAIC_IMAGE_SOURCE ? null : (
          <div>
            <Button
              color='primary'
              className='button'
              onClick={() => window.open(profileURL, '_blank')}
            >
              {viewText}
            </Button>
            {viewButtonComponent}
          </div>
        )}
      </div>
    );
  }
}

export default DesignDescription;
